module.exports = __webpack_public_path__ + "img/dora-icon.f6bbf196.svg";